module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title d-flex align-items-center"
  }, [_c('span', {
    staticClass: "mr-2 mt-2 mb-2"
  }, [_vm._v("Create New Folder")]), _vm._v(" "), (_vm.updating) ? _c('Loader') : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  })]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createFolder($event)
      }
    }
  }, [_c('div', {
    staticClass: "field has-addons w-100p"
  }, [_c('div', {
    staticClass: "control is-medium grow-1",
    class: _vm.creating && 'is-loading'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.folderTitle),
      expression: "folderTitle"
    }],
    staticClass: "input is-medium",
    attrs: {
      "placeholder": "New folder name"
    },
    domProps: {
      "value": (_vm.folderTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.folderTitle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control is-medium"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    class: _vm.creating && 'is-loading',
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  Create\n              ")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-1712dd80"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddFolderModal.vue
// module id = 989
// module chunks = 0